<template>
  <div
    class="h5-image-search"
    :style="getDialogStyle"
  >
    <div
      class="canvas-image-wrapper"
    >
      <div class="image-list-box">
        <div
          v-if="croppers.length"
          class="image-list"
        >
          <div
            class="image-box"
            v-for="(item, index) in croppers"
            :key="index"
          >
            <img
              @click="onCropperChange(item, index)"
              :src="item.imgUrl"
              alt=""
            >
            <div :class="{active: index === selected}" />
          </div>
        </div>
        <div
          v-else
          class="image-list"
        >
          <div
            class="image-box"
            v-for="(, index) in 3"
            :key="index"
          >
            <div
              class="mockImg"
              :class="{ first: index === 0 }"
            />
            <div :class="{active: index === selected}" />
          </div>
        </div>
      </div>
      <div
        class="close"
        @click="onClose"
      >
        <img
          src="@/assets/close-circle-icon.svg"
          alt=""
        >
      </div>
    </div>
    <H5Dialog
      class="custom-image-search-dialog"
      v-model="showImageSearchDlg"
      :style="{
        background: 'transparent'
      }"
      :height="`calc(100% - 60px)`"
    >
      <H5BestdealerPublicity class="h5-image-search__publicity" />
      <div
        class="h5-image-search__list"
      >
        <div
          v-if="list.length > 0 && !loading"
          class="h5-image-search__title"
        >
          <div
            class="text1"
          >
            Results for <span>"Similar Recommendations"</span>
          </div>
          <div class="text2">
            All items are sold directly by the manufacturer.
          </div>
        </div>
        <Product
          :loading="loading"
          :product-list="list"
          @load="onLoad"
          @item-click="onItemClick"
        />
      </div>
    </H5Dialog>
  </div>
</template>

<script setup>
import H5Dialog from '@/components/H5/H5Dialog/index.vue'
import { buriedPointUtil, gaAnalytics, openURLWithChannelQuery } from '@/utils/utils'
import { useRouter } from 'vue-router'
import { useProductList } from '../ImageSearch/hooks/useProductList'
import { Product } from '@/components/NewProduct'
import H5BestdealerPublicity from '@/components/BestdealerPublicity/H5BestdealerPublicity.vue'

const router = useRouter()

const selected = ref(0)

const showImageSearchDlg = ref(false)

onMounted(() => {
  showImageSearchDlg.value = true
})

const onClose = () => {
  showImageSearchDlg.value = false
  nextTick(() => {
    router.back()
  })
}

const { filter, croppers, loading, list, onLoad, onReset } = useProductList()

const onCropperChange = async (item, index) => {
  selected.value = index
  buriedPointUtil({ eventId: 'MPSI201' })

  filter.region = item.coordinate.join(',')
  onReset()
}

const onItemClick = (item) => {
  buriedPointUtil({ eventId: 'MPSC205', spuId: item.offerId })
  gaAnalytics('mp_search_page_click', 'mp_search_page_click', { spuId: item.offerId })
  openURLWithChannelQuery(`/offer/${item.offerId}?key=${btoa(item.monthSold)}&adding=${btoa(item.addingCount)}`)
}

const getDialogStyle = computed(() => {
  if (filter.imageAddress == null) return {}
  return {
    background: `linear-gradient(rgba(0, 0, 0, 0.64), rgba(0, 0, 0, 0.64)),
                url(${filter.imageAddress})`,
    'background-size': 'cover',
    'background-position': 'center',
    'background-repeat': 'no-repeat'
  }
})

onMounted(() => {
  gaAnalytics('mp_search_page_view', 'mp_search_page_view')
})
</script>

<style lang="less" scoped>
@import url('./index.less');

.custom-image-search-dialog {
  ::v-deep(.popup-content) {
    background-color: white;
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(8px);
    z-index: -1;
  }

  :deep(.scroll-content) {
    padding: 0 16px 16px;
  }
}

.bottom-search-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 66px;
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 80));
  z-index: 9999;
  .search-bar {
    position: relative;
    width: 240px;
    height: 52px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    background-color: white;
    border-radius: 26px;
    box-shadow: 0 0 8px #00000016;
    &::before {
      position: absolute;
      content: '';
      width: 0.5px;
      height: 24px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #E4E6EB;
    }
  }

  .find-similar, .find-styles {
    font-size: 14px;
    color: #b2b7c2;
    font-family: mon-600;
    padding: 7px 0;
    height: 33px;
    -webkit-tap-highlight-color: transparent; /* 透明点击高亮 */

    &.active {
      position: relative;
      color: #232323;
      &::after {
        content: '';
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 0;
        height: 2px;
        background-color: #232323;
      }
    }
  }
}
</style>
